import { oc } from '@orpc/contract';
import { getTemplateVersionInputSchema, templateVersionSchema } from '../schemas/templates.schemas.js';
export const getTemplateVersionContract = oc
    .route({
    method: 'GET',
    path: '/templates/versions/{versionId}',
    tags: ['Templates'],
    summary: 'One template version with its shared values',
})
    .input(getTemplateVersionInputSchema)
    .output(templateVersionSchema);
//# sourceMappingURL=get-template-version.contract.js.map